export const ROUTES = {
  LOGIN: '/login',
  PATIENTS: '/patients',
  PATIENT_DETAIL: '/patients/:id',
  PATIENT_PRE_RECORD: '/patients/:id/pre-record',
  PATIENT_RECORD: '/patients/:id/record',
  PATIENT_ADMISSION: '/patients/:id/admission',
  PATIENT_REVIEW: '/patients/:id/review',
  PATIENT_GENERATING: '/patients/:id/generating',
  RECORD: '/record',
  FREE_RECORD: '/free-record',
  GENERATING: '/generating',
  REVIEW: '/review',
  NOTES: '/notes',
  NOTE_DETAIL: '/notes/:id',
  VITALS: '/vitals',
  VITAL_DETAIL: '/vitals/:id',
  REPORTS: '/reports',
  REPORT_DETAIL: '/reports/:id',
  MEDICATIONS: '/medications',
  MEDICATION_DETAIL: '/medications/:id',
  FLUID_BALANCE: '/fluid-balance',
  PATIENT_FLUID_BALANCE: '/patients/:id/fluid-balance',
  PROFILE: '/profile',
  ONBOARDING: '/onboarding',
  PATIENT_SELECT: '/select-patient',
  SHIFT_HANDOVER: '/shift-handover',
  SHIFT_HANDOVER_GENERATING: '/shift-handover/generating',
  SHIFT_HANDOVER_VOICE: '/shift-handover/voice/:patientKey',
  SHIFT_HANDOVER_VOICE_GENERATING: '/shift-handover/voice-generating',
  ACCESS_CODE: '/access-code',
  JOIN: '/join',
  DOCTOR_HOME: '/doctor',
  DOCTOR_SIGNUP: '/doctor/signup',
  DOCTOR_LOGIN: '/doctor/login',
  DOCTOR_ONBOARDING: '/doctor/onboarding',
  DOCTOR_PATIENTS: '/doctor/patients',
  DOCTOR_PATIENT_NEW: '/doctor/patients/new',
  DOCTOR_PATIENT_DETAIL: '/doctor/patients/:id',
  DOCTOR_PATIENT_EDIT: '/doctor/patients/:id/edit',
  DOCTOR_GENERATING: '/doctor/patients/:id/generating',
  DOCTOR_REVIEW: '/doctor/patients/:id/review',
  DOCTOR_NOTE_DETAIL: '/doctor/notes/:noteId',
  DOCTOR_NOTES: '/doctor/notes',
  DOCTOR_PAYWALL: '/doctor/paywall',
  DOCTOR_SETTINGS: '/doctor/settings',
};

export function doctorPatientPath(id) {
  return `/doctor/patients/${id}`;
}

export function doctorPatientEditPath(id) {
  return `/doctor/patients/${id}/edit`;
}

export function doctorGeneratingPath(id) {
  return `/doctor/patients/${id}/generating`;
}

export function doctorReviewPath(id) {
  return `/doctor/patients/${id}/review`;
}

export function doctorNotePath(noteId) {
  return `/doctor/notes/${noteId}`;
}

export function patientPath(id) {
  return `/patients/${id}`;
}

export function patientPreRecordPath(id) {
  return `/patients/${id}/pre-record`;
}

export function patientRecordPath(id) {
  return `/patients/${id}/record`;
}

export function patientAdmissionPath(id) {
  return `/patients/${id}/admission`;
}

export function patientGeneratingPath(id) {
  return `/patients/${id}/generating`;
}

export function patientReviewPath(id) {
  return `/patients/${id}/review`;
}

export function notePath(id) {
  return `/notes/${id}`;
}

export function vitalPath(id) {
  return `/vitals/${id}`;
}

export function reportPath(id) {
  return `/reports/${id}`;
}

export function medicationPath(id) {
  return `/medications/${id}`;
}

export function patientFluidBalancePath(id) {
  return `/patients/${id}/fluid-balance`;
}

export function shiftHandoverVoicePath(patientKey) {
  return `/shift-handover/voice/${encodeURIComponent(patientKey)}`;
}
